import { render } from "./AlarmAccordion.vue?vue&type=template&id=bacabc44"
import script from "./AlarmAccordion.vue?vue&type=script&lang=js"
export * from "./AlarmAccordion.vue?vue&type=script&lang=js"

import "./AlarmAccordion.vue?vue&type=style&index=0&id=bacabc44&lang=css"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__